import { configureStore } from '@reduxjs/toolkit'
import { AboutApi } from '../helpers/aboutApi';
import { AlertApi } from '../helpers/alertApi';
import { BlogApi } from '../helpers/blogApi';
import { ListenApi } from '../helpers/ListenApi';
import { NewsApi } from '../helpers/newsApi';
import { PressApi } from '../helpers/pressNewsApi';
import { projectApi } from '../helpers/projectsApi';
import { reviewApi } from '../helpers/reviewApi';
import { SendEmail } from '../helpers/SendEmailApi';
import { TalkIconsApi } from '../helpers/talkIconsApi';
import { VacancyApi } from '../helpers/vacancyApi';
import { statisticsApi } from '../helpers/StatisticsApi';
import { TechnologyApi } from '../helpers/technologyApi';


const store = configureStore({
    reducer : {
        [SendEmail.reducerPath]  : SendEmail.reducer, 
        [BlogApi.reducerPath]  : BlogApi.reducer, 
        [NewsApi.reducerPath]  : NewsApi.reducer, 
        [PressApi.reducerPath]  : PressApi.reducer, 
        [VacancyApi.reducerPath]  : VacancyApi.reducer, 
        [reviewApi.reducerPath]  : reviewApi.reducer, 
        [projectApi.reducerPath]  : projectApi.reducer, 
        [AlertApi.reducerPath]  : AlertApi.reducer, 
        [AboutApi.reducerPath]  : AboutApi.reducer, 
        [TalkIconsApi.reducerPath]  : TalkIconsApi.reducer, 
        [ListenApi.reducerPath]  : ListenApi.reducer, 
        [statisticsApi.reducerPath]  : statisticsApi.reducer, 
        [TechnologyApi.reducerPath]  : TechnologyApi.reducer, 

    },
    middleware : (getDefaultMiddleware)=> getDefaultMiddleware().concat(SendEmail.middleware).concat(BlogApi.middleware).concat(NewsApi.middleware).concat(PressApi.middleware).concat(VacancyApi.middleware).concat(reviewApi.middleware).concat(projectApi.middleware).concat(AlertApi.middleware).concat(AboutApi.middleware).concat(TalkIconsApi.middleware).concat(ListenApi.middleware).concat(statisticsApi.middleware).concat(TechnologyApi.middleware)

})

export default store;